"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getConditionSchema = void 0;
const schemaComponents_1 = require("@/schemaComponents");
const getConditionSchema = ({ langId, }) => {
    return (0, schemaComponents_1.mergeSchema)({ schemaType: "object", properties: [] }, [
        {
            title: "テキストID",
            propertyName: "scriptId",
            schema: {
                schemaType: "text",
                required: true,
            },
        },
        {
            title: "テキスト",
            propertyName: "text",
            schema: {
                schemaType: "text",
            },
        },
        ...(langId
            ? [
                {
                    title: "翻訳文", //  検索用
                    propertyName: `translations.${langId}`,
                    schema: {
                        schemaType: "text",
                    },
                },
            ]
            : []),
    ]);
};
exports.getConditionSchema = getConditionSchema;
